import React, { useState } from "react";
import { Button, Modal, Form, Table, InputGroup } from "react-bootstrap";
import { FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import LoadingSpinner from "../../../Components/spinner";
import { toast } from "sonner";

import { useNavigate } from "react-router-dom";
import { toggleAdUnitStatus } from "../../../services/axios/apiManager";
import AddEditUnitModal from "./addEditModal";
import { deleteAdUnit } from "../../../services/axios/apiManager";
import UnitDetailsModal from "./detailsModal";

const AdsUnitsList = ({ adUnits, getAdUnits, adsAPIId, apiName }) => {
  const navigate = useNavigate();
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState({});
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  // // //Handle Status Change
  const handleStatusChange = async (unit) => {
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of "${unit.name}"?`,
      okay: "Change",
      method: changeStatus,
      data: {
        apiId: adsAPIId,
        unitId: unit.id,
        status: unit.status === 1 ? 0 : 1,
      },
    });
    setShowOptionsModal(true);
  };
  // // // Status Change Logic
  const changeStatus = async (data) => {
    setLoading(true);
    const response = await toggleAdUnitStatus(data);
    if (response?.data?.success) {
      await getAdUnits();
    }
    setModalOptions({});
    setShowOptionsModal(false);
    setLoading(false);
  };
  // // // Handle Delete Unit
  const handledelete = async (unit) => {
    setModalOptions({
      header: "Delete",
      body: `Are you sure you want to delete "${unit.name}"?`,
      warning: true,
      okay: "Delete",
      method: deleteUnit,
      data: {
        apiId: adsAPIId,
        unitId: unit.id,
      },
    });
    setShowOptionsModal(true);
  };
  // // // Delete Unit Logic
  const deleteUnit = async (data) => {
    setLoading(true);
    const response = await deleteAdUnit(data.apiId, data.unitId);
    if (response?.data?.success) {
      await getAdUnits();
    }
    setModalOptions({});
    setShowOptionsModal(false);
    setLoading(false);
  };
  // // // Open options Prmopt Modal
  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };
  // // // Open Add/Edit Modal
  const handleShowModal = (unit) => {
    setSelectedUnit(unit);
    setShowAddEditModal(true);
  };
  // // // Close Add/Edit Modal
  const handleHideModal = () => {
    setShowAddEditModal(false);
    setSelectedUnit({});
  };
  // // // Open Details Modal
  const handleOpenDetails = (unit) => {
    setSelectedUnit(unit);
    setShowDetailsModal(true);
  };
  // // // Open Details Modal
  const closeDetails = () => {
    setShowDetailsModal(false);
    setSelectedUnit({});
  };
  return (
    <div
      className="container py-4 text-light bg-dark p-3 rounded mb-4"
      data-testid="ads-units-list"
    >
      <div className="row align-items-center mb-2">
        <div className="d-flex justify-content-end">
          {loading && <LoadingSpinner size={"lg"} className={"mr-3 mt-1"} />}
          <div className="text-end">
            <Button
              title="go back"
              variant="success"
              className="mb-3 d-flex"
              data-testid="go-back-button"
              onClick={() => {
                navigate(-1);
              }}
              style={{ float: "right" }}
            >
              Go Back
            </Button>
          </div>
          <div className="ml-2 text-end">
            <Button
              title="Add New Unit"
              variant="success"
              className="mb-3 d-flex"
              data-testid="add-new-button"
              onClick={() => {
                handleShowModal({});
              }}
              style={{ float: "right" }}
            >
              Add New
            </Button>
          </div>
        </div>
      </div>

      <div className="table-responsive mt-2">
        {adUnits?.length > 0 ? (
          <Table className="table-hover table-striped align-middle table-borderless table-dark">
            <thead>
              <tr>
                <th>Name</th>
                <th>ID</th>
                <th>Ad Format</th>
                <th>Type</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {adUnits.map((unit) => (
                <tr key={unit?.id} data-testid={`unit-row-${unit?.id || 1}`}>
                  <td>{unit?.name}</td>
                  <td>{unit?.id}</td>
                  <td>{unit?.ad_format}</td>
                  <td>{unit?.type}</td>
                  <td>
                    <button
                      className={`btn btn-link p-0 m-0 border-0 ${
                        unit?.status ? "text-success" : "text-danger"
                      }`}
                      onClick={() => {
                        handleStatusChange(unit);
                      }}
                      style={{ textDecoration: "none" }}
                      title="change status"
                      data-testid={`status-button-${unit?.id || 1}`}
                    >
                      {unit?.status ? "Active" : "Inactive"}
                    </button>
                  </td>
                  <td>
                    <Button
                      variant="outline-success"
                      size="sm"
                      onClick={() => {
                        handleOpenDetails(unit);
                      }}
                      title="view details"
                    >
                      <FaEye />
                    </Button>
                    <Button
                      variant="outline-primary"
                      className="mx-1"
                      size="sm"
                      onClick={() => {
                        handleShowModal(unit);
                      }}
                      title="edit"
                    >
                      <FaEdit />
                    </Button>
                    {unit?.status === 0 && (
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => {
                          handledelete(unit);
                        }}
                        title="delete"
                      >
                        <FaTrashAlt />
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div className="d-flex justify-content-center">
            <span className="text-light">No Ad units found for this API</span>
          </div>
        )}
      </div>
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
          {modalOptions.warning && (
            <div className="d-flex">
              <p className="mt-2 mr-2 ">⚠️</p>
              <p className="text-danger text-lg mt-2">
                This action is not reversible.
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
      <AddEditUnitModal
        selectedUnit={selectedUnit}
        setSelectedUnit={setSelectedUnit}
        showAddEditModal={showAddEditModal}
        handleHideModal={handleHideModal}
        getAdUnits={getAdUnits}
        apiId={adsAPIId}
      />
      <UnitDetailsModal
        showDetailsModal={showDetailsModal}
        selectedUnit={selectedUnit}
        setSelectedUnit={setSelectedUnit}
        closeDetails={closeDetails}
        apiName={apiName}
      />
    </div>
  );
};
export default AdsUnitsList;
